import { render, staticRenderFns } from "./unify.vue?vue&type=template&id=22f1b36a&scoped=true"
import script from "./unify.vue?vue&type=script&lang=js"
export * from "./unify.vue?vue&type=script&lang=js"
import style0 from "./unify.vue?vue&type=style&index=0&id=22f1b36a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1b36a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f1b36a')) {
      api.createRecord('22f1b36a', component.options)
    } else {
      api.reload('22f1b36a', component.options)
    }
    module.hot.accept("./unify.vue?vue&type=template&id=22f1b36a&scoped=true", function () {
      api.rerender('22f1b36a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/afterSalesSetting/unify.vue"
export default component.exports